export const UK_POSTCODE_REGEX = /^[a-zA-Z]{1,2}([0-9]{1,2}|[0-9][a-zA-Z])[0-9][a-zA-Z]{2}$/;

export function normalizeUkPostcode(value = '') {
  return `${value}`.toUpperCase().replace(/\W/g, '');
}

export function isValidUkPostcode(value = '') {
  return UK_POSTCODE_REGEX.test(normalizeUkPostcode(value));
}
